import React from 'react';
import { Create } from 'react-admin';
import AlcanceForm from '../AlcanceForm';

function AlcanceCreate(props) {
  return (
    <Create {...props}>
      <AlcanceForm redirect="list" />
    </Create>
  );
}

export default AlcanceCreate;
